export default __webpack_public_path__ + "static/media/softwareDeveloper.53f529c5.jpg";